import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import SalesIntegrations from '~/components/Admin/IntegrationPage/SalesIntegrations/SalesIntegrations';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { clientId } = params;

  const nav = {
    actions: [
      {
        text: intl.formatMessage({
          id: 'IntegrationsDeprecated.navTitle',
          defaultMessage: 'Integrations',
          description: 'Navigation title for integrations page',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientIntegrations, {
          clientId: clientId as string,
        }),
      },
      {
        text: intl.formatMessage({
          id: 'CRM.pageTitle',
          defaultMessage: 'CRM',
          description: 'CRM page title',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientCRM, {
          clientId: clientId as string,
        }),
      },
    ],
  };

  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'CRM.pageTitle',
        defaultMessage: 'CRM',
        description: 'CRM page title',
      })}
      nav={nav}
    >
      <SalesIntegrations />
    </PageLayout>
  );
};

export default Page;
